import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import AddSalesOrderModal from "./AddSalesOrderModal";
import {
  BRAND_COLOR,
  BRAND_HOVER,
  useKivunovaTranslation
} from "@kivunova/kivufrontendcommon";

export interface NoSalesOrderFoundProps {
  /** When true, omit full-viewport height so the block fits inside a table row. */
  compact?: boolean;
}

const NoSalesOrderFound: React.FC<NoSalesOrderFoundProps> = ({
  compact = false
}) => {
  const [openAddModal, setOpenAddModal] = useState(false);
  const { t } = useKivunovaTranslation();

  return (
    <Box
      sx={{
        p: compact ? 2 : 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        ...(compact ? {} : { height: "70vh" })
      }}
    >
      <Typography variant="h5" fontWeight="bold" mb={2} color="text.primary">
        {t("no-sales-orders-found", "No sales orders found")}
      </Typography>
      <Typography color="text.secondary" mb={3}>
        {t(
          "no-sales-orders-description",
          "It looks like there are no sales orders yet."
        )}
        <br />
        {t(
          "no-sales-orders-cta-hint",
          "Click below to create your first sales order."
        )}
      </Typography>

      <Box>
        <Button
          variant="contained"
          onClick={() => setOpenAddModal(true)}
          data-testid="create-sales-order-btn"
          sx={{
            backgroundColor: BRAND_COLOR,
            "&:hover": {
              backgroundColor: BRAND_HOVER
            },
            textTransform: "none"
          }}
        >
          {t("create-sales-order", "Create Sales Order")}
        </Button>
      </Box>

      <AddSalesOrderModal
        open={openAddModal}
        onClose={() => setOpenAddModal(false)}
      />
    </Box>
  );
};

export default NoSalesOrderFound;
